/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const MANU_AR_TBL_DATA = 'MANU_AR_TBL_DATA';
export const MANU_AR_FLD_DATA = 'MANU_AR_FLD_DATA';
export const MANU_AR_UNALLOCATED_VAL = 'MANU_AR_UNALLOCATED_VAL';
export const MANU_AR_SHOW_SELECT = 'MANU_AR_SHOW_SELECT';
export const AR_MANU_NAV_DATA = 'AR_MANU_NAV_DATA';
export const NDC_DETAIL_SIGNLE_MFG = 'NDC_DETAIL_SIGNLE_MFG';
export const NDC_DETAIL_ALL_MFG = 'NDC_DETAIL_ALL_MFG';
export const MFG_AR_FIRST_LOAD = 'MFG_AR_FIRST_LOAD';
export const MFG_ACCOUNT_REC_CLEAR_REDUX = 'MFG_ACCOUNT_REC_CLEAR_REDUX';
